import Link from 'next/link';

interface SectionHeaderProps {
  title: string;
  moreLink?: string;
  moreLabel?: string;
  light?: boolean;
}

export default function SectionHeader({ title, moreLink, moreLabel, light }: SectionHeaderProps) {
  return (
    <div className={`flex items-baseline justify-between mb-5 pb-2.5 border-b-[2.5px] ${light ? 'border-white' : 'border-[#0D0D0D]'}`}>
      <h2 className={`font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[12px] tracking-[0.1em] uppercase ${light ? 'text-white' : 'text-[#0D0D0D]'}`}>
        {title}
      </h2>
      {moreLink && moreLabel && (
        <Link
          href={moreLink}
          className={`font-['IBM_Plex_Sans',system-ui,sans-serif] font-semibold text-[12px] uppercase tracking-[0.04em] transition-colors ${
            light
              ? 'text-white/70 hover:text-white'
              : 'text-[#C8102E] hover:text-[#9E0C23]'
          }`}
        >
          {moreLabel}
        </Link>
      )}
    </div>
  );
}
